export default __webpack_public_path__ + "static/media/eb-ultra-blk-poster-1.f60053db.jpg";